import { getDividerStyles } from './DividerStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { DividerVariant } from './types/variant.js';

const Divider = _ref => {
  let {
    variant = DividerVariant.GRAY,
    ...rest
  } = _ref;
  return jsx("hr", {
    css: getDividerStyles(variant),
    ...rest
  });
};

export { Divider };
//# sourceMappingURL=Divider.js.map
